import { render, staticRenderFns } from "./list-courses.vue?vue&type=template&id=4e5b9873&scoped=true"
import script from "./list-courses.vue?vue&type=script&lang=js"
export * from "./list-courses.vue?vue&type=script&lang=js"
import style0 from "./list-courses.vue?vue&type=style&index=0&id=4e5b9873&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5b9873",
  null
  
)

export default component.exports